$(document).on('ready turbolinks:load', function() {

  var toggleButton = function(target) {
    const buttonElement = document.getElementById(target+ '-button');
    const selectElement = document.getElementById(target+ '-select');
    if (selectElement != null) {
      if (selectElement.value === '') {
        buttonElement.disabled = true;
        $(buttonElement).addClass("disabled btn-nonactive");
      } else {
        buttonElement.disabled = false;
        $(buttonElement).removeClass("disabled btn-nonactive");
      }
    }
  }
  toggleButton('facility');
  toggleButton('tag');
  $("select[id='facility-select']").change(function() {
    toggleButton('facility');
  });
  $("select[id='tag-select']").change(function() {
    toggleButton('tag');
  });
});